import { render, staticRenderFns } from "./teaching.vue?vue&type=template&id=24925191&scoped=true"
import script from "./teaching.vue?vue&type=script&lang=js"
export * from "./teaching.vue?vue&type=script&lang=js"
import style0 from "./teaching.vue?vue&type=style&index=0&id=24925191&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24925191",
  null
  
)

export default component.exports